import { ProductType, ActionButtonConfig } from '../../../hooks/useEarnProduct';
import { getSpotMarketConfig } from 'src/utils/api';
import {
	MAIN_POOL_ID,
	JLP_POOL_ID,
	EXPONENT_POOL_ID,
	SACRED_POOL_ID,
	LST_POOL_ID,
} from '@velocity-exchange/common';

// Helper functions to derive UI metadata from productType and marketIndex

export const getPoolName = (poolId: number): string => {
	switch (poolId) {
		case MAIN_POOL_ID:
			return 'Main Market';
		case JLP_POOL_ID:
			return 'JLP Market';
		case SACRED_POOL_ID:
			return 'ACRED Market';
		case EXPONENT_POOL_ID:
			return 'Exponent Market';
		case LST_POOL_ID:
			return 'LST Market';
		default:
			return 'Unknown Market';
	}
};

export const getProductTitle = (
	productType: ProductType,
	marketIndex: number
): string => {
	const spotMarket = getSpotMarketConfig(marketIndex);
	if (!spotMarket) return 'Unknown Product';

	switch (productType) {
		case 'borrow_lend':
			return `Lending - ${getPoolName(spotMarket.poolId)}`;
		case 'insurance_fund_vaults':
			return `Insurance Fund Vaults - ${getPoolName(spotMarket.poolId)}`;
		case 'governance':
			return 'Drift Safety Module';
		case 'd_sol_staking':
			return 'dSOL Liquid Staking';
		case 'strategy_vaults':
			return 'Strategy Vaults';
		case 'amplify':
			return 'Amplify - JLP';
		default:
			return 'Unknown Product';
	}
};

export const getActionButtons = (
	productType: ProductType
): ActionButtonConfig[] => {
	switch (productType) {
		case 'borrow_lend':
			return [
				{ type: 'deposit', highlight: true },
				{ type: 'see_all' },
				{ type: 'details' },
			];
		case 'insurance_fund_vaults':
			return [
				{ type: 'stake', highlight: true, mobileText: 'Stake' },
				{ type: 'see_all' },
				{ type: 'details' },
			];
		case 'governance':
			return [
				{ type: 'stake', highlight: true },
				{ type: 'see_all' },
				{ type: 'details' },
			];
		case 'd_sol_staking':
			return [{ type: 'stake_sol', highlight: true }];
		case 'strategy_vaults':
			return [{ type: 'view_vaults', highlight: true }];
		case 'amplify':
			return [{ type: 'view_amplify', highlight: true }];
		default:
			return [];
	}
};

export const isRangeApy = (productType: ProductType) =>
	productType === 'strategy_vaults' || productType === 'amplify';

export const createApyInfoAction = (
	productType: ProductType,
	marketIndex: number,
	setDrawerStore: any,
	spotMarketLookup: any
) => {
	switch (productType) {
		case 'borrow_lend':
			return () => {
				setDrawerStore((s: any) => {
					s.borrowLendDetails = {
						show: true,
						market: spotMarketLookup[marketIndex],
						displayTab: 'deposit',
					};
				});
			};
		case 'insurance_fund_vaults':
		case 'governance':
			return () => {
				setDrawerStore((s: any) => {
					s.insuranceFundVault.show = true;
					s.insuranceFundVault.marketIndex = marketIndex;
				});
			};
		default:
			return undefined;
	}
};

// TODO: make actual logic for this
const NEW_MARKET_INDICES = [];
export const isNew = (marketIndex: number) => {
	return false;
	return NEW_MARKET_INDICES.includes(marketIndex);
};
